/**
 * Value Stack
 */

export default function HWY_ValueStack() {
	const selectors = {
		title : ".value-title",
		image : ".value-image",
		container: ".values-container"
	};

	this.init = () => {
		jQuery(".value-title, .value-image").on("click", function() {
			const link = jQuery(this).data("link");
			if (link) {
				const target = jQuery(this).data("target");
				if (target == '_blank')
					window.open(link, "_blank");
				else
					window.location.href = link;
			}
		})

		jQuery(selectors.title).on("mouseenter", function() {
			jQuery(this).closest(selectors.container).find(selectors.title).removeClass("active");
			jQuery(this).closest(selectors.container).find(selectors.image).removeClass("active");
			jQuery(this).addClass("active");

			const index = jQuery(this).data("index");
			jQuery(`.value-image[data-index='${index}']`).addClass("active");
		})

		let timer = setInterval(iterateValues, 6000)

		jQuery(".value-title").hover( function() {
			clearInterval(timer);
		}, function () {
			timer = setInterval(iterateValues, 6000)
		});
	};

	const iterateValues = () => {
		jQuery(".value-title.active").each(function() {
			const count = jQuery(this).closest(selectors.container).find(selectors.title).length;
			const index = (1 + jQuery(this).data("index")) % count;
			jQuery(this).closest(selectors.container).find(selectors.title).removeClass("active");
			jQuery(this).closest(selectors.container).find(selectors.image).removeClass("active");
			jQuery(this).closest(selectors.container).find(`.value-image[data-index='${index}']`).addClass("active");
			jQuery(this).closest(selectors.container).find(`.value-title[data-index='${index}']`).addClass("active");
		});
	}
}
